// One canonical implementation lives under CRA's src/ boundary so both the
// legacy Elakay pages and the standalone CJ module render the same modal.
module.exports = require("../../../src/includes/pageInside/sync/CJSyncActionModal");
